import React, { useCallback } from "react";

import { faArrowsToLine } from "@awesome.me/kit-4c83d50d0d/icons/classic/regular";
import cx from "classnames";

import { platform } from "~/lib/utils/platform";
import { Button, LabelIconForButton } from "~/ui/button/Button";

import { TitleBarPortal } from "./TitleBarProvider";

import styles from "./CompanionModeTitleBar.module.css";

export function CompanionModeTitleBar() {
	const collapseIntoHandle = useCallback(() => {
		window.CompanionModeAPI?.collapseIntoHandle();
	}, []);

	// The additional version check can go away once all users have updated to desktop v1.6.0 or above.
	if (platform === "browser" || navigator.userAgent.includes("FellowCompanionMode/0.0.1")) return null;

	return (
		<TitleBarPortal
			instanceName="Companion mode title bar"
			containerClassName={cx(styles.titleBarContainer, styles[platform])}
		>
			<Button
				variant="tertiary"
				size="slim"
				className={`text-(--secondaryTextColor)`}
				style={{ "app-region": "no-drag" }}
				onClick={collapseIntoHandle}
			>
				Collapse
				<LabelIconForButton side="right" icon={faArrowsToLine} />
			</Button>
		</TitleBarPortal>
	);
}
